import { Injectable } from '@angular/core';
import { BaseService } from '@core/service/base.service';
import { HttpClient } from '@angular/common/http';
import { catchError, tap } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PriceDetailsService extends BaseService{

  private url = 'api/dynamic-form';  // URL to web api

  constructor(http: HttpClient) {
    super(http);
  }

  getUrl(): string {
    return this.url;
  }

  /**
   *
   * @param code
   */
  getByCode(code:String):Observable<any> {
    const url = `${this.getUrl()}/code/${code}`;
    return this.http.get<any>(url).pipe(
      tap(_ => this.log(`fetched object code=${code}`)),
      catchError(this.handleError<any>(`get any code=${code}`))
    );
  }

}
